import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@ublend-npm/aulaui-core';
import { ENTER, SPACE } from '@app/utils/keyCodes';

const StatusButtons = ({
  initialStatusText,
  initialEmojiShortName,
  statusText,
  emojiShortName,
  onSave,
  onUndo,
  isSaving,
}) => {
  const isUnchanged =
    initialStatusText === statusText &&
    initialEmojiShortName === emojiShortName;
  const isEmpty = !emojiShortName.length;

  let buttonTitle;
  if (isUnchanged) buttonTitle = 'Status set';
  else if (!initialStatusText.length || !initialEmojiShortName.length)
    buttonTitle = 'Set status';
  else buttonTitle = 'Update status';

  return (
    <Button
      data-testid="set-status-button"
      sx={{
        textTransform: 'none',
      }}
      onClick={onSave}
      kind="primary"
      loading={isSaving}
      disabled={isUnchanged || isSaving}
      onKeyDown={(e) =>
        (e.keyCode === ENTER || e.keyCode === SPACE) && onSave()
      }
    >
      Save
    </Button>
  );
};

StatusButtons.propTypes = {
  initialStatusText: PropTypes.string.isRequired,
  initialEmojiShortName: PropTypes.string.isRequired,
  statusText: PropTypes.string.isRequired,
  emojiShortName: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onUndo: PropTypes.func.isRequired,
  isSaving: PropTypes.bool.isRequired,
};

export default StatusButtons;
